import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { setSnackbarMessage, setUser, setUserLoginFailed } from '../model/configuratorSlice';
import { EndPoints, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { LoginTokenAuth } from '../auth/LoginTokenAuth';
import { DownloadTokenAuth } from '../auth/DownloadToken';
import { RequestBudgetTokenAuth } from '../auth/RequetBudgetToken';
import IsNullOrUndefined from '../utils/ObjectUtils';
import { HabitatTokenAuth } from '../auth/HabitatTokenAuth';

export default function UserService() {
    const { promotionSlug } = useParams();
    const dispatch = useDispatch();

    return useMutation(['userQuery'], (payload) => {
        const userUrl = `${EndPoints.UserUrl}/${promotionSlug}`;

        const headers = {
            [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
        };

        if (!IsNullOrUndefined(payload.login_token)) {
            headers[LoginTokenAuth.HeaderName] = `token ${payload.login_token}`;
        }

        if (!IsNullOrUndefined(payload.download_token)) {
            headers[DownloadTokenAuth.HeaderName] = `token ${payload.download_token}`;
        }

            if (!IsNullOrUndefined(payload.request_budget_token)) {
            headers[RequestBudgetTokenAuth.HeaderName] = `token ${payload.request_budget_token}`;
        }

        if (!IsNullOrUndefined(payload.habitat_token)) {
            headers[HabitatTokenAuth.HeaderName] = `token ${payload.habitat_token}`;
        }

        const config = {
            headers,
        };

        axios
            .get(userUrl, config)
            .then((response) => {
                dispatch(setUser(response.data));
                const saved = AccessTokenAuth.TrySaveAccessToken(response.headers.authorization);
                LoginTokenAuth.DeleteAccessToken();
            })
            .catch((error) => {
                console.log(error.response.data);
                dispatch(setUserLoginFailed(error.response.data));
            });
    });
}
